import { format } from 'date-fns'
import { getEffectiveStartDate } from 'Data/payment-plan.js'

export function getEffectiveFrom(insured) {
  let result = getEffectiveStartDate(insured)
  return result ? format(result, 'MMMM do, yyyy') : '-'
}
